module.exports = __webpack_public_path__ + "static/media/me-9.c0fe44e3.svg";